import { Map, List, OrderedMap } from "immutable";
import { COMPANY_LOS_ACTIONS, STATE_STATUS } from "../constants";
import { DisbursalRequestRecord, DisbursalJobRecord } from "../records";
import moment from "moment";

const DEFAULT_STATE = new Map({
    requests: new Map({}),
    jobs: new Map({}),
    jobsStatus: STATE_STATUS.UNFETCHED,
    jobsCount: new Map({
        status: STATE_STATUS.UNFETCHED,
        data: new Map({})
    }),
    filter: {
        status: "pending",
        search: ""
    },
    dealers : {
        status : STATE_STATUS.UNFETCHED,
        data : List()
    },
    emailStatus: STATE_STATUS.UNFETCHED,
});

const JOB_STAGES_FOR_REVIEWER = [
    "Approved",
    "Pending",
    "Hold",
    "Rejected",
    "Duplicate",
    "Processed",
];

export default (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
    case COMPANY_LOS_ACTIONS.FETCH_CREATE_INVOICE_JOB:
        return state.setIn(
            ["requests", payload.requestId],
            new DisbursalRequestRecord({
                id: payload.requestId,
                status: STATE_STATUS.CREATING,
                job: null,
                totalParsedInvoices: 0,
                seller: payload.seller,
                invoices: payload.invoiceFiles
            })
        );
    case COMPANY_LOS_ACTIONS.FETCHED_CREATE_INVOICE_JOB:
        return state
            .setIn(
                ["requests", payload.requestId, "status"],STATE_STATUS.CREATED) 
            .setIn(
                ["requests", payload.requestId, "job"],payload.response)
            .setIn(
                ["jobs", payload.response.id],
                new DisbursalJobRecord({
                    id: payload.response.id,
                    status: STATE_STATUS.FETCHED,
                    job: payload.response
                })
            );
    case COMPANY_LOS_ACTIONS.FAILED_FETCH_CREATE_INVOICE_JOB:
        return state
            .setIn(
                ["requests", payload.requestId, "status"],STATE_STATUS.CREATE_FAILED);
    case COMPANY_LOS_ACTIONS.UPDATE_INVOICE_JOB_STATUS:
        return state
            .setIn(
                ["requests", payload.requestId, "totalParsedInvoices"],payload.totalParsedInvoices)
            .setIn(
                ["jobs", payload.jobId, "invoices"], new List(payload.invoices).map(_ => ({
                    ..._,
                    invoice_date: (_.invoice_date && moment(_.invoice_date, "YYYY-MM-DD").isValid()) ? moment(_.invoice_date, "YYYY-MM-DD") : null
                })))
            .setIn(
                ["jobs", payload.jobId, "invoicesStatus"], STATE_STATUS.FETCHED)
            .setIn(["jobs", payload.jobId, "job", "stage"], payload.totalParsedInvoices === payload.invoices.length ? "Processed" : "Processing");
    case COMPANY_LOS_ACTIONS.FETCH_INVOICE_JOB:
        return state.setIn(
            ["jobs", payload.jobId, "invoicesStatus"], STATE_STATUS.FETCHING);
    case COMPANY_LOS_ACTIONS.FETCHED_INVOICE_JOB:
        return state
            .setIn(
                ["jobs", payload.jobId, "invoicesStatus"], STATE_STATUS.FETCHED)
            .setIn(
                ["jobs", payload.jobId, "invoices"], new List(payload.invoices).map(_ => ({
                    ..._,
                    invoice_date: (_.invoice_date && moment(_.invoice_date, "YYYY-MM-DD").isValid()) ? moment(_.invoice_date, "YYYY-MM-DD") : null
                })));
    case COMPANY_LOS_ACTIONS.FAILED_FETCH_INVOICE_JOB:
        return state
            .setIn(
                ["jobs", payload.jobId, "invoicesStatus"], STATE_STATUS.FETCH_FAILED);
    case COMPANY_LOS_ACTIONS.CLEAR_INVOICE_JOB:
        return state.removeIn(["jobs", payload.jobId]);
    case COMPANY_LOS_ACTIONS.FETCH_UPDATE_INVOICE_JOB: {
        const invoiceMap = List(payload.invoices).toMap().mapEntries(([,v]) => [v.id, v]);
        return state
            .setIn(
                ["jobs", payload.jobId, "invoicesStatus"], STATE_STATUS.UPDATING)
            .setIn(
                ["jobs", payload.jobId, "invoices"], state.getIn(["jobs", payload.jobId, "invoices"], List([])).map(_ => invoiceMap.get(_.id, _)));
    }
    case COMPANY_LOS_ACTIONS.FETCHED_UPDATE_INVOICE_JOB:
        return state
            .setIn(
                ["jobs", payload.jobId, "invoicesStatus"], STATE_STATUS.UPDATED);
    case COMPANY_LOS_ACTIONS.FAILED_FETCH_UPDATE_INVOICE_JOB:
        return state
            .setIn(
                ["jobs", payload.jobId, "invoicesStatus"], STATE_STATUS.FAILED_UPDATE);
    case COMPANY_LOS_ACTIONS.FETCH_REMOVE_INVOICE: {
        return state
            .setIn(
                ["jobs", payload.jobId, "invoicesStatus"], STATE_STATUS.UPDATING);
    }
    case COMPANY_LOS_ACTIONS.FETCHED_REMOVE_INVOICE:
        return state
            .setIn(
                ["jobs", payload.jobId, "invoicesStatus"], STATE_STATUS.UPDATED)
            .setIn(
                ["jobs", payload.jobId, "invoices"], new List(payload.remainingInvoices));
    case COMPANY_LOS_ACTIONS.FAILED_FETCH_REMOVE_INVOICE:
        return state
            .setIn(
                ["jobs", payload.jobId, "invoicesStatus"], STATE_STATUS.FAILED_UPDATE);


    case COMPANY_LOS_ACTIONS.FETCH_ALL_INVOICE_JOB:
        if (payload.email === "yes") {
            return state.setIn(["emailStatus"], STATE_STATUS.FETCHING);
        }
        if(payload.page === 1){
            return state.setIn(["jobsStatus"], STATE_STATUS.FETCHING)
                .setIn(
                    ["filter"], {
                        status: payload.status,
                        search: payload.search,
                        page: payload.page,
                        start_date: payload.start_date, 
                        end_date: payload.end_date,
                        email: payload.email,
                    }
                ).setIn(["jobs"], new Map({}));
        }
        return state
            .setIn(
                ["jobsStatus"], STATE_STATUS.FETCHING)
            .setIn(
                ["filter"], {
                    status: payload.status,
                    search: payload.search,
                    page: payload.page,
                    start_date: payload.start_date, 
                    end_date: payload.end_date,
                    email: payload.email,
                }
            );
    case COMPANY_LOS_ACTIONS.FETCHED_ALL_INVOICE_JOB:
        if (state.get("emailStatus") === STATE_STATUS.FETCHING) {
            return state.setIn(["emailStatus"], STATE_STATUS.FETCHED);
        }
        if(payload.page === 1){
            return state
                .setIn(
                    ["jobsStatus"], STATE_STATUS.FETCHED)
                .setIn(["filter", "count"], payload.jobs.count)
                .set("noDataMessage", payload.jobs.count === 0 ? payload.message || "No Invoice exist in selected date range." : null)
                .setIn(
                    ["jobs"], 
                    new List(payload.jobs.results
                        // ?.filter((_) => JOB_STAGES_FOR_REVIEWER.includes(_.status))
                        .map(_ => new DisbursalJobRecord({
                            id: _.id,
                            status: STATE_STATUS.FETCHED,
                            job: _,
                        }))).toMap().mapEntries(([,v]) => [v.id, v]));
        }
        return state
            .setIn(
                ["jobsStatus"], STATE_STATUS.FETCHED)
            .setIn(["filter", "count"], payload.jobs.count)
            .set("noDataMessage", payload.jobs.count === 0 ? payload.message || "No Invoice exist in selected date range." : null)
            .mergeIn(
                ["jobs"], 
                new List(payload.jobs.results
                    // ?.filter((_) => JOB_STAGES_FOR_REVIEWER.includes(_.status))
                    .map(_ => new DisbursalJobRecord({
                        id: _.id,
                        status: STATE_STATUS.FETCHED,
                        job: _,
                    }))).toMap().mapEntries(([,v]) => [v.id, v]));
    case COMPANY_LOS_ACTIONS.FAILED_FETCH_ALL_INVOICE_JOB:
        return state
            .setIn(
                ["jobsStatus"], STATE_STATUS.FETCH_FAILED);


    case COMPANY_LOS_ACTIONS.FETCH_INVOICE_CARDS:
        return state
            .setIn(["jobsCount"], new Map({
                data: null,
                status: STATE_STATUS.FETCHING,
            }));
    case COMPANY_LOS_ACTIONS.FETCHED_INVOICE_CARDS:
        return state
            .setIn(["jobsCount"], new Map({
                data: new OrderedMap(payload.count),
                status: STATE_STATUS.FETCHED,
            }));
    case COMPANY_LOS_ACTIONS.FAILED_FETCH_INVOICE_CARDS:
        return state
            .setIn(
                ["jobsCount", "status"], STATE_STATUS.FETCH_FAILED);
    // case COMPANY_LOS_ACTIONS.FETCH_MARK_JOB_PENDING:
    //     return state.setIn(
    //         ["jobs", payload.jobId, "status"], STATE_STATUS.UPDATING);
    // case COMPANY_LOS_ACTIONS.FETCHED_MARK_JOB_PENDING:
    //     return state
    //         .setIn(
    //             ["jobs", payload.jobId, "status"], STATE_STATUS.UPDATED)
    //         .setIn(
    //             ["jobs", payload.jobId, "job", "stage"], "Review Pending");
    // case COMPANY_LOS_ACTIONS.FAILED_FETCH_MARK_JOB_PENDING:
    //     return state
    //         .setIn(
    //             ["jobs", payload.jobId, "status"], STATE_STATUS.UPDATE_FAILED);
    case COMPANY_LOS_ACTIONS.FETCH_FINAL_SUBMISSION:
        return state.setIn(
            ["jobs", payload.jobId, "status"], STATE_STATUS.UPDATING);
    case COMPANY_LOS_ACTIONS.FETCHED_FINAL_SUBMISSION:
        return state
            .setIn(
                ["jobs", payload.jobId, "status"], STATE_STATUS.UPDATED)
            .setIn(
                ["jobs", payload.jobId, "job", "stage"], payload.type  === "maker" ? "Review Initialized" : "Review Closed");
    case COMPANY_LOS_ACTIONS.FAILED_FETCH_FINAL_SUBMISSION:
        return state
            .setIn(
                ["jobs", payload.jobId, "status"], STATE_STATUS.UPDATE_FAILED);

    case COMPANY_LOS_ACTIONS.FETCH_DEALERS_FROM_GSTIN:
        return state.setIn(
            ["dealers", "status"], STATE_STATUS.FETCHING);
    case COMPANY_LOS_ACTIONS.FETCHED_DEALERS_FROM_GSTIN:
        console.log("in fetched ", payload.response);
        return state
            .setIn(
                ["dealers", "status"], STATE_STATUS.FETCHED)
            .setIn(
                ["dealers", "data"], payload.response);
    case COMPANY_LOS_ACTIONS.FAILED_FETCH_DEALERS_FROM_GSTIN:
        return state
            .setIn(
                ["dealers", "status"], STATE_STATUS.FETCH_FAILED);
    default: 
        return state;
    }
};
